exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive[data-v-5cdba446]{max-width:100%;height:auto}.transfer-img-frame[data-v-5cdba446]{width:100%;max-width:160px;height:100px;border:1px solid #e0e0e0;border-radius:8px;background:#fafafa;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto}", ""]);

// exports
